import { useCallback, useState } from 'react';

import Intermediation from '~/components/organisms/SalesStatement/Intermediation';
import Klok from '~/components/organisms/SalesStatement/Klok';

import * as G from '~/components/Globals';
import {
  SaleStatementTypeEnum,
  SaleStatementTypeEnumLabel,
} from '~/domain/enum/salesStatement/saleStatementType.enum';
import * as S from './SalesStatement.styled';

export default function SalesStatementByType() {
  const [activeKey, setActiveKey] = useState<SaleStatementTypeEnum>(
    SaleStatementTypeEnum.Intermediation,
  );

  const handleTabChange = useCallback(
    (key: string) => {
      setActiveKey(key as SaleStatementTypeEnum);
    },
    [setActiveKey],
  );

  return (
    <div>
      <G.TabContainer onChange={handleTabChange} activeKey={activeKey}>
        <G.TabContainer.TabPane
          tab={SaleStatementTypeEnumLabel[SaleStatementTypeEnum.Intermediation]}
          key={SaleStatementTypeEnum.Intermediation}
        >
          <S.Container>
            <Intermediation />
          </S.Container>
        </G.TabContainer.TabPane>
        <G.TabContainer.TabPane
          tab={SaleStatementTypeEnumLabel[SaleStatementTypeEnum.Klok]}
          key={SaleStatementTypeEnum.Klok}
        >
          <S.Container>
            <Klok />
          </S.Container>
        </G.TabContainer.TabPane>
      </G.TabContainer>
    </div>
  );
}
